















































































import { Component, Vue, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import { AuthService } from '@/data/services/auth.service';
import { PasswordRegex, ResetPassword } from '@/data/models/reset-password.model';
import { BaseError } from '@/data/models/error.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class LoginComponent extends Vue {
	@Inject('AuthService') authService!: AuthService;

	password: string = '';
	passwordRepeat: string = '';

	error?: string = '';
	loading: boolean = false;

	passwordRegex = PasswordRegex;
	token!: string;

	mounted() {
		this.token = '' + this.$route.query.token;
	}

	submit() {
		const resetPasswordReq = new ResetPassword();
		resetPasswordReq.md5password = this.password;
		resetPasswordReq.token = this.token;
		this.loading = true;
		this.authService
			.resetPasswordApply(resetPasswordReq)
			.then(() => {
				this.$buefy.notification.open({
					message: this.$t('password-modificata-success').toString(),
					type: 'is-success',
				});
				this.$router.push({ path: '/login' });
				
			})
			.catch(({ data }) => {
				this.error = (data as BaseError).msg;
			}).finally(() => this.loading = false);
	}
}
